import TransferHistory from 'features/moveMoney/screens/transferHistory/TransferHistory';
import React from 'react';

export default function TransferHistoryPage() {
  return <TransferHistory />;
}
